/**
 * State carried into the share dialog, and on to the advanced editor.
 *
 * - `presetVideoUrl` is set by the "Edit" button on a climb video: it
 *   pre-selects that video in the editor.
 * - `openedInApp` says the dialog was opened from a page of ours, which is then
 *   the one behind it in the history: closing it is a step back. Without it (a
 *   link to `/share`, a reload) closing goes to the climb's page instead.
 */
export interface ShareNavigationState {
  presetVideoUrl?: string;
  openedInApp?: boolean;
}

/** Where the share dialog opens over a climb's page: `…/boulders/x/share`. */
export function shareDialogPath(climbPath: string): string {
  return `${climbPath}/share`;
}

/** The advanced editor, a page of its own: `…/boulders/x/share/advance/new`. */
export function shareAdvancedPath(climbPath: string): string {
  return `${climbPath}/share/advance/new`;
}

/** Whether this address is the share dialog's (and not the advanced editor's). */
export function isShareDialogPath(pathname: string): boolean {
  return /\/share\/?$/.test(pathname);
}
